export const NAME = 'presses';